import * as React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { MenuItem } from 'primereact/menuitem';
import { useIsMobile } from '../../helpers/hooks/useIsMobile';
import styles from './PageBreadCrumb.module.css';

interface PageBreadCrumbProps {
    items: BreadCrumbItem[];
    grayAncestors?: boolean;
}
export interface BreadCrumbItem extends MenuItem {
    status?: BreadCrumbItemStatus;
}
export interface BreadCrumbItemStatus {
    Id?: number;
    Title?: string;
    mapBadgeClass: (statusId?: number) => string;
}

export const PageBreadCrumb: React.FC<PageBreadCrumbProps> = ({ items, grayAncestors }) => {
    const isMobile = useIsMobile(900);

    const onItemClick = (e: React.MouseEvent, item: MenuItem) => {
        e.preventDefault();
        if (item.command) item.command({ originalEvent: e, item });
    };

    const renderStatus = (status: BreadCrumbItemStatus) => {
        const cls = status.mapBadgeClass(status.Id);
        return (
            <span className={`${styles.badge} ${cls}`}>
                <span className={styles.dot} />
                {status.Title}
            </span>
        );
    };

    return (
        <div className={styles.nav}>
            {items.map((item, idx) => {
                const isLast = idx + 1 === items.length;
                const label = grayAncestors && !isLast
                    ? <span className={styles.ancestorLabel}>{item.label}</span>
                    : item.label;
                return (
                    <React.Fragment key={idx}>
                        {idx > 0 && (
                            <i className={`fa-solid fa-chevron-right ${styles.sep}`} />
                        )}
                        {isLast ? (
                            <span className={styles.current} style={{ fontSize: isMobile ? 16 : 19 }}>
                                {item.label ?? <Skeleton height="1em" width="5rem" />}
                                {item.status && renderStatus(item.status)}
                            </span>
                        ) : item.label ? (
                            item.url || item.command ? (
                                <a
                                    className={styles.link}
                                    href={item.url ?? '#'}
                                    onClick={e => onItemClick(e, item)}
                                >
                                    {label}
                                    {item.status && renderStatus(item.status)}
                                </a>
                            ) : (
                                <span className={styles.link}>
                                    {label}
                                    {item.status && renderStatus(item.status)}
                                </span>
                            )
                        ) : (
                            <Skeleton height="1em" width="3rem" />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};
